export const APPS_REDIRECT_SECONDS = 5;
